import { create } from "zustand";
import { getEnableOnlineAuction } from "../api/blackbirdApiService";

const featureFlagStore = create((set) => ({
  enableOnlineAuction: false,
  isLoaded: false,
  fetchFeatureFlags: async () => {
    try {
      const enableOnlineAuction = await getEnableOnlineAuction();
      set({ enableOnlineAuction, isLoaded: true });
    } catch (error) {
      console.error("Error fetching feature flags:", error);
      set({ isLoaded: true });
    }
  },
}));

export default featureFlagStore;